import React from 'react';
import PropTypes from 'prop-types';

/**
 * Cubo's mark: a 7 by 7 grid of rounded squares that shades from light to dark cyan, with two gaps.
 *
 * @param {Object} props - Component props.
 * @param {number} [props.borderRadius=0] - Rounds the outer corners of the whole icon, in pixels.
 * @param {number} [props.size=26] - Width and height in pixels.
 * @param {string} [props.label='Cubo'] - Accessible name, read by screen readers.
 * @param {boolean} [props.isDecorative=false] - Hide it from screen readers when its name is already next to it.
 * @returns {React.ReactElement} The icon.
 */
const CuboIcon = ({borderRadius = 0, isDecorative = false, label = 'Cubo', size = 26}) => (
  <svg width={size} height={size} viewBox="0 0 69 69" {...(isDecorative ? {'aria-hidden': true} : {role: 'img', 'aria-label': label})} style={{borderRadius, flex: '0 0 auto'}}>
    <rect x="0" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="10" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="20" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="30" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="40" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="50" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="60" y="0" width="9" height="9" rx="1" fill="#86e9f7" />
    <rect x="0" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="10" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="20" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="30" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="40" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="50" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="60" y="10" width="9" height="9" rx="1" fill="#74e0f3" />
    <rect x="0" y="20" width="9" height="9" rx="1" fill="#5fd6ee" />
    <rect x="10" y="20" width="9" height="9" rx="1" fill="#5fd6ee" />
    <rect x="30" y="20" width="9" height="9" rx="1" fill="#5fd6ee" />
    <rect x="50" y="20" width="9" height="9" rx="1" fill="#5fd6ee" />
    <rect x="60" y="20" width="9" height="9" rx="1" fill="#5fd6ee" />
    <rect x="0" y="30" width="9" height="9" rx="1" fill="#4ccbe6" />
    <rect x="10" y="30" width="9" height="9" rx="1" fill="#4ccbe6" />
    <rect x="30" y="30" width="9" height="9" rx="1" fill="#4ccbe6" />
    <rect x="50" y="30" width="9" height="9" rx="1" fill="#4ccbe6" />
    <rect x="60" y="30" width="9" height="9" rx="1" fill="#4ccbe6" />
    <rect x="0" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="10" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="20" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="30" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="40" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="50" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="60" y="40" width="9" height="9" rx="1" fill="#3bc0de" />
    <rect x="0" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="10" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="20" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="30" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="40" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="50" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="60" y="50" width="9" height="9" rx="1" fill="#2fb6d8" />
    <rect x="0" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="10" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="20" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="30" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="40" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="50" y="60" width="9" height="9" rx="1" fill="#24aed2" />
    <rect x="60" y="60" width="9" height="9" rx="1" fill="#24aed2" />
  </svg>
);

CuboIcon.propTypes = {
  borderRadius: PropTypes.number,
  isDecorative: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.number,
};

export default CuboIcon;
